import React, { useEffect, useMemo, useState } from 'react';
import { formatTime } from '../utils';
import { getTime } from '../assets/index';

export const TimeIndividualChat = ({ conversation }) => {
  const [time, setTime] = useState('00:00:00');
  const formattedTime = useMemo(() => formatTime(time), [time]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(
        getTime(
          conversation?.dateOfLastAction ||
            conversation?.timeline?.[conversation.timeline.length - 1]
              ?.horaAtividade ||
            conversation?.hora_criacao
        )
      );
    }, 1000);
    return () => clearInterval(timer);
  }, [conversation]);

  return <>{formattedTime}</>;
};
